// Form validation for Mail server settings form
import { emailValidator, plaintextValidator } from '../fields';

const config = { mandatory: true };

export const mailboxConstraints = (args) => ({
  incomingAddress: emailValidator(config),
  outgoingAddress: emailValidator(config),
  'client.name': plaintextValidator(args.mode === 'default' ? {} : config)
});

export const newMailboxConstraints = (args) => ({
  outgoingAddress: emailValidator(config)
});

export const otherMailboxConstraints = (args) => ({
  userName: emailValidator(config),
  password: plaintextValidator(config),
  imapHost: plaintextValidator(config),
  smtpHost: plaintextValidator(config),
  imapPort: plaintextValidator(config),
  smtpPort: plaintextValidator(config)
});

export const microsoftMailboxConstraints = (args) => ({
  incomingAddress: emailValidator(config)
});
